import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton  from 'material-ui/FlatButton';
import { localize } from 'react-localize-redux';

/**
 * usato per mostrare lo spinner di caricamento in list
 * @param {*} param0
 */
const ButtonLoaderWithText = ({ translate, currentLanguage }) => (
    <FlatButton  label={translate('GLOBAL.loading')}
        disabled={true}
        icon={<CircularProgress size={25} />}>
    </FlatButton >
);

export default localize(ButtonLoaderWithText, 'locale');


// WEBPACK FOOTER //
// ./src/components/loaders/ButtonLoaderWithText.js